<script setup lang="ts">
/**
 * BON04 — Increase of Paid-Up Capital (Bonus Issue).
 * Word 템플릿 `Increase of Paid-Up Capital (Bonus Issue).docx` 문장/표/Common Seal 구조에 맞춤.
 */
import { computed, inject } from 'vue';
import { BONUS_DOC_CTX } from './bonusContext';
import BonusDocVarField from './BonusDocVarField.vue';
import BonusDocHead from './parts/BonusDocHead.vue';
import BonusDcrIntro from './parts/BonusDcrIntro.vue';
import BonusAllotteeTable from './parts/BonusAllotteeTable.vue';
import BonusSigners from './parts/BonusSigners.vue';

const ctx = inject(BONUS_DOC_CTX)!;
const hasConstitution = computed(() => ctx.flag('has_constitution'));
</script>

<template>
  <div class="allot-doc">
    <BonusDocHead />
    <BonusDcrIntro />

    <p class="doc-sec-title" style="margin-bottom:2px">ALLOTMENT OF SHARES</p>
    <p class="doc-sec-title" style="margin-top:0">CAPITALIZATION OF RESERVES</p>

    <p class="doc-p">
      THAT pursuant to the Members' Resolution passed on the
      <BonusDocVarField field-key="mwr_date" />
      authorising the Director(s) to capitalize the sum of RM
      <BonusDocVarField field-key="reserve_amount" />
      being part of the
      <BonusDocVarField field-key="reserve_type" />
      of the Company, the following shares be and are hereby allotted on the basis of
      <BonusDocVarField field-key="bonus_ratio_new" />
      (<BonusDocVarField field-key="bonus_ratio_new_words" />)
      new fully paid ordinary shares of RM
      <BonusDocVarField field-key="share_price" />
      each for every
      <BonusDocVarField field-key="bonus_ratio_existing" />
      (<BonusDocVarField field-key="bonus_ratio_existing_words" />)
      existing ordinary held as at
      <BonusDocVarField field-key="record_date" />:
    </p>

    <BonusAllotteeTable shares-header="No. of Shares Allotted Otherwise than cash" />

    <p class="doc-p" style="margin-top:12px">
      And that such shares allotted shall rank pari passu in all respect with the existing ordinary shares of the Company.
    </p>
    <p class="doc-p">
      THAT the Common Seal of the Company be and is hereby authorised to affixed onto the new share certificate(s) to be issued
      in respect thereof in accordance with the
      <span
        class="doc-toggle"
        title="Constitution / Articles of Association"
        @click="ctx.toggleFlag('has_constitution')"
      >{{ hasConstitution ? 'Constitution' : 'Articles of Association' }}</span>
      of the Company.
    </p>

    <p class="doc-lbl-title">BOARD OF DIRECTORS</p>
    <BonusSigners var-key="increase" board-label="BOARD OF DIRECTORS" />
    <p class="doc-p" style="margin-top:14px"><b>Date:</b> <BonusDocVarField field-key="dcr_date" /></p>

    <!-- Word 템플릿 CONTINUATION PAGE 2 헤더 -->
    <div class="page-div">— — — Continuation — — —</div>
    <p class="doc-p" style="text-align:center;font-weight:700">
      <BonusDocVarField field-key="company_name" />
      [Company Registration No.
      <BonusDocVarField field-key="company_registration_no" />
      (<BonusDocVarField field-key="old_registration_no" />)]
    </p>
    <p class="doc-sec-title" style="font-size:0.95em">
      DIRECTORS' CIRCULAR RESOLUTION - ALLOTMENT OF SHARES (CAPITALIZATION OF RESERVES)
      CONTINUATION PAGE 2
    </p>
  </div>
</template>
